// lib/authValidation.ts
import Cookies from "js-cookie";

export const authValidation = async (): Promise<boolean> => {
    try {
        const res = await fetch('/api/validate-token');
        if (!res.ok) throw new Error('Invalid');

        const data = await res.json();
        if (data.role !== 'superAdmin' && data.role !== 'admin') {
            throw new Error('Forbidden');
        }

        return true;
    } catch (err) {
        Cookies.remove('authToken');
        return false;
    }
};
